if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // Initialize form state
        this.initializeForm();
      }

      initializeForm() {
        // Add event listener for size selection
        const sizeInputs = document.querySelectorAll('input[name="Size"]');
        sizeInputs.forEach(input => {
          input.addEventListener('change', () => {
            this.validateForm();
          });
        });

        // Initial validation
        this.validateForm();
      }

      validateForm() {
        const sizeInputs = document.querySelectorAll('input[name="Size"]');
        const hasSize = Array.from(sizeInputs).some(input => input.checked);
        
        if (!hasSize) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('button--disabled');
          this.handleErrorMessage('Please select a size');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('button--disabled');
          this.handleErrorMessage();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          this.handleErrorMessage('Please select a size before adding to cart');
          return;
        }

        // Check if size is selected
        const sizeInputs = document.querySelectorAll('input[name="Size"]');
        const selectedSize = Array.from(sizeInputs).find(input => input.checked);
        
        if (!selectedSize) {
          this.handleErrorMessage('Please select a size before adding to cart');
          return;
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Ensure variant ID is set
        const variantId = selectedSize.dataset.variantId;
        if (variantId) {
          formData.set('id', variantId);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            this.error = false;

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('An error occurred. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
